import { MouseEvent } from "react";
import { Box } from "@mui/material";
import { IActionPlan } from "entities/RCA/ActionPlanEntity/ActionPlanEntityInterfaces";
import { DatePicker } from "@mui/x-date-pickers";
import useDateFormat from "hooks/useDateFormat";
import { useStyles } from "../../hooks/useActionPlansTableColumns.styles";
import { useActionPlanDueDateCell } from "./useActionPlanDueDateCell";

interface IActionPlanDueDateCellProps {
    row: IActionPlan;
}

const ActionPlanDueDateCell = ({ row }: IActionPlanDueDateCellProps) => {
    const classes = useStyles();
    const { getDateFormatByLanguage, formatDate } = useDateFormat();
    const { isEditing, dueDate, handleDueDateChange } = useActionPlanDueDateCell(row);

    if (isEditing) {
        return (
            <Box
                onClick={(event: MouseEvent<HTMLDivElement>) => {
                    event.stopPropagation();
                }}
                sx={{ width: "160px", minWidth: 0, display: "flex", justifyContent: "center" }}
            >
                <DatePicker
                    className={`${classes.inlineFormDatePicker}`}
                    value={dueDate}
                    disablePast
                    format={getDateFormatByLanguage()}
                    onChange={handleDueDateChange}
                />
            </Box>
        );
    }

    return <div style={{ textAlign: "center" }}>{formatDate(row.due_date)}</div>;
};

export default ActionPlanDueDateCell;
